import { Component } from '@angular/core';
import { AlertsvarService } from 'src/app/alerts/alertsvar.service';
import { UntypedFormGroup,FormGroup,FormControl } from '@angular/forms';
import { OnInit,AfterViewInit,OnDestroy} from '@angular/core';
import { RoutecrumpsService } from 'src/app/services/routecrumps.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-consolidation-rule',
  templateUrl: './consolidation-rule.component.html',
  styleUrls: ['./consolidation-rule.component.scss']
})
export class ConsolidationRuleComponent {

  errstr=''
  alertId=''
  platform=''
  alertName=''
  ruleType=''
  fieldError:boolean=false
  timeError:boolean=false
  showTest:boolean=false
  constructor(public alertvarservice:AlertsvarService,public rcrumpService:RoutecrumpsService,public router:Router){}

  ngOnInit(){
    this.alertvarservice.convertPlatformFields()

    if(this.alertvarservice.editState){
      this.description.setValue(this.alertvarservice.editrequested.value.description)
      this.alertId=this.alertvarservice.editrequested.value.ruleFor
      this.conditions.setValue(this.alertvarservice.editrequested.value.conditions)
      this.context.setValue(this.alertvarservice.editrequested.value.context)
//console.log("Alert Id",this.alertId)
    }
    else{
      this.activate.setValue(true)
      this.alertvarservice.$alert.subscribe(value => {
//console.log('alert>>>>>>>>>', value);
        this.alertId=value["alertId"]
        this.platform=value["platform"]
        this.alertName=value["alertTitle"]
      });
      this.alertvarservice.$ruleGroup.subscribe(value => {
//console.log('ruleType>>>>>>>>>', value);
        this.ruleType=value
      });
    }
  }


  ngAfterViewInit(){
    this.description.valueChanges.subscribe(data=>{
//console.log("Description---->",data)
    })

    this.activate.valueChanges.subscribe(data=>{
//console.log("activate---->",data)
    })

    this.retroactive.valueChanges.subscribe(data=>{
//console.log("retroactive---->",data)
    })

    this.fields.valueChanges.subscribe(data=>{
//console.log("fields---->",data)
      if(this.fields.valid){
        this.fieldError=false
      }
      else{
        this.fieldError=true
      }
    })

    this.timeframe.valueChanges.subscribe(data=>{
//console.log("timeframe---->",data)
      if(this.timeframe.valid){
        this.timeError=false
      }
      else{
        this.timeError=true
      }
    })
  }

  get context(){
    return this.alertvarservice.consolidation.get("context") as UntypedFormGroup
  }
  get description(){
    return this.context.get("description")
  }
  get activate(){
    return this.context.get("activate")
  }
  get retroactive(){
    return this.context.get("retroactive")
  }

  get conditions(){
    return this.alertvarservice.consolidation.get("conditions") as UntypedFormGroup
  }
  get fields(){
    return this.conditions.get("fields")
  }
  get timeframe(){
    return this.conditions.get("timeframe")
  }


  removeChip(chip:any){
    let index = this.fields.value.findIndex(item => item === chip);
    this.fields.value.splice(index, 1);
    let empty=null
    let field=this.fields.value
//console.log(this.fields.value)
    this.fields.setValue(empty)
    this.fields.setValue(field)
  }

  verifyquery(){
    // this.alertvarservice.testResultVolume=true
    this.showTest=true
  }

  cancelClick(){
//console.log("CancelClicked")
    if(this.alertvarservice.editState){
      this.fieldError=false
      this.timeError=false
      this.showTest=false
      this.alertvarservice.resetConsolidation()
      this.router.navigateByUrl('/rule')
    
    }else{
      this.fieldError=false
      this.timeError=false
      this.showTest=false
      this.router.navigateByUrl('/explorelogs')
      this.alertvarservice.resetConsolidation()
      this.rcrumpService.route_crumps.length = 2;
      
    }
  }

  postSatusChange(status: any) {
    if (status) {
      return 1
    } else {
      return 0
    }
  }

  engineCheck(postvalue:any){
    if(!this.alertvarservice.compareobjects(this.alertvarservice.editrequested.value,postvalue)){
      return true
    }else{
      return false
    }
  }

  

  submitClicked(){
//console.log("Consolidation--->",this.alertvarservice.consolidation)

    if(!this.fields.valid){
      this.fieldError=true
    }
    if(!this.timeframe.valid){
      this.timeError=true
    }

    if(this.fields.valid && this.timeframe.valid){
      let postvalue=[]

      if(this.alertvarservice.editState){
        if(this.alertvarservice.editrequested.value.status_change != this.activate.value){
          this.alertvarservice.status_change=true
        }
        postvalue["platform"]=this.alertvarservice.editrequested.value.platform
        postvalue["name"]=this.alertvarservice.editrequested.value.name
        postvalue["type"]=this.alertvarservice.editrequested.value.type
        postvalue["ruleFor"]=this.alertvarservice.editrequested.value.ruleFor
        postvalue["description"]=this.alertvarservice.editrequested.value.description
        postvalue["status"]=this.postSatusChange(this.activate.value)
        postvalue["enginechange"]=this.engineCheck(postvalue)
        postvalue["ruleId"]=this.alertvarservice.editrequested.value?.ruleId
        postvalue["activate_rule"]=this.activate.value
        postvalue["retroactive"]=this.retroactive.value
        postvalue["status_change"]=this.alertvarservice.status_change
        postvalue["signature_fields"]=this.alertvarservice.convertFieldsToPost()
        postvalue["timeframe"]=this.timeframe.value
    }
    else{
      Object.assign(postvalue, { ruleFor: this.alertId, description: this.description.value, platform: this.platform, type: this.ruleType, name: this.alertName, status: this.postSatusChange(this.activate.value), enginechange: true,activate_rule:this.activate.value,retroactive:this.retroactive.value,status_change:this.alertvarservice.status_change,timeframe:this.timeframe.value});
      postvalue["signature_fields"]=this.alertvarservice.convertFieldsToPost()

    }

      // console.log("Field",this.alertvarservice.convertFieldsToPost())
      // console.log(this.alertvarservice.consolidation.getRawValue())
//console.log(postvalue)
    } 
  }

  ngOnDestroy(){
    this.fieldError=false
    this.timeError=false
    this.showTest=false
    this.alertvarservice.resetConsolidation()
    this.alertvarservice.editrequested.state=false
    this.alertvarservice.editrequested.value=null
  }
   

}
